export default __webpack_public_path__ + "static/media/logo-header.6e42b461.svg";